<div>
        <div class="setting-wrapper">


                <div class="container-fluid">
                        <div class="form-modified">
                                <div class="error-list" v-if="errorsMessage">
                                        <ul class="error-msg">
                                                <li v-for="(error,x) in errorsMessage" :key="x">
                                                        <div v-for="(err,i) in error" :key="i">
                                                                <p> {{err}}</p>
                                                        </div>
                                                </li>
                                        </ul>
                                </div>
                                <div class="form-group row">
                                        <label for="" class="col-lg-2 col-form-label">From</label>
                                        <div class="col-lg-5">
                                                <label v-if="!ShowReadonly" for="staticEmail"
                                                        class="readonly">{{Email.FromName}}</label>
                                                <input v-else type="text" id="inputPassword" placeholder="Name"
                                                        class="form-control mb-3" v-model="Email.FromName">
                                        </div>
                                        <div class="col-lg-5">
                                                <label v-if="!ShowReadonly" for="staticEmail"
                                                        class="readonly">{{Email.FromEmail}}</label>
                                                <input v-else type="text" id="inputPassword" placeholder="Email"
                                                        class="form-control" v-model="Email.FromEmail">
                                        </div>
                                </div>
                                <div class="form-group row">
                                        <label for="" class="col-lg-2 col-form-label">CC</label>
                                        <div v-for="(item, cc_index) in Email.Cc" :key="cc_index">
                                                <div class="col-lg-5">
                                                        <label v-if="!ShowReadonly" for="staticEmail"
                                                                class="readonly">{{item.name}}</label>
                                                        <input v-else type="text" id="inputPassword" placeholder="Name"
                                                                class="form-control " v-model="item.name">
                                                </div>
                                                <div class="col-lg-5">
                                                        <label v-if="!ShowReadonly" for="staticEmail"
                                                                class="readonly">{{item.email}}</label>
                                                        <input v-else type="text" id="inputPassword" placeholder="Email"
                                                                class="form-control" v-model="item.email">
                                                </div>
                                        </div>
                                        <button type="submit" class="btn default-btn cancel"
                                                @click.prevent="addCcEmail()">
                                                Add CC
                                        </button>
                                </div>
                                <div class="form-group row">
                                        <label for="" class="col-lg-2 col-form-label">BCC</label>
                                        <div v-for="(item, bcc_index) in Email.Bcc" :key="bcc_index">
                                                <div class="col-lg-5">
                                                        <label v-if="!ShowReadonly" for="staticEmail"
                                                                class="readonly">{{item.name}}</label>
                                                        <input v-else type="text" id="inputPassword" placeholder="Name"
                                                                class="form-control " v-model="item.name">
                                                </div>
                                                <div class="col-lg-5">
                                                        <label v-if="!ShowReadonly" for="staticEmail"
                                                                class="readonly">{{item.email}}</label>
                                                        <input v-else type="text" id="inputPassword" placeholder="Email"
                                                                class="form-control " v-model="item.email">
                                                </div>

                                                </span>
                                                <button type="submit" class="btn default-btn add-btn"
                                                        @click.prevent="addBccEmail">
                                                        <i class="fas fa-plus"></i> Add BCC
                                                </button>
                                        </div>
                                        <div class="form-group row">
                                                <label for="" class="col-lg-2 col-form-label">Port</label>
                                                <div class="col-lg-10">
                                                        <label v-if="!ShowReadonly" for="staticEmail"
                                                                class="readonly">{{Email.Port}}</label>
                                                        <input v-else type="text" id="inputPassword"
                                                                placeholder="Port number" class="form-control "
                                                                v-model="Email.Port">
                                                </div>
                                        </div>
                                        <div class="form-group row">
                                                <label for="" class="col-lg-2 col-form-label">Mail driver</label>
                                                <div class="col-lg-10">
                                                        <label v-if="!ShowReadonly" for="staticEmail"
                                                                class="readonly">{{Email.MailDriver}}</label>
                                                        <input v-else type="text" id="inputPassword"
                                                                placeholder="Mail driver" class="form-control "
                                                                v-model="Email.MailDriver">
                                                </div>
                                        </div>
                                        <div class="form-group row">
                                                <label for="" class="col-lg-2 col-form-label">Host</label>
                                                <div class="col-lg-10">
                                                        <label v-if="!ShowReadonly" for="staticEmail"
                                                                class="readonly">{{Email.HostName}}</label>
                                                        <input v-else type="text" id="inputPassword"
                                                                placeholder="Host name" class="form-control "
                                                                v-model="Email.HostName">
                                                </div>
                                        </div>
                                        <div class="form-group row">
                                                <label for="" class="col-lg-2 col-form-label">Encryption</label>
                                                <div class="col-lg-10">
                                                        <div v-if="!ShowReadonly">
                                                                <label v-if="Email.Encryption" for="staticEmail"
                                                                        class="readonly">{{Email.Encryption.name}}</label>
                                                        </div>
                                                        <div v-else>
                                                                <div class="multiselect-input" v-if="EncryptionList">
                                                                        <multiselect :options='EncryptionList'
                                                                                label="name" :track-by="'id'"
                                                                                v-model="Email.Encryption"
                                                                                placeholder="Choose tour type..">
                                                                        </multiselect>
                                                                </div>
                                                        </div>
                                                </div>
                                        </div>
                                        <div class="form-group row">
                                                <label for="" class="col-lg-2 col-form-label">User Name</label>
                                                <div class="col-lg-10">
                                                        <label v-if="!ShowReadonly" for="staticEmail"
                                                                class="readonly">{{Email.UserName}}</label>
                                                        <input v-else type="text" id="inputPassword"
                                                                placeholder="Host name" class="form-control "
                                                                v-model="Email.UserName">
                                                </div>
                                        </div>
                                        <div class="form-group row">
                                                <label for="" class="col-lg-2 col-form-label">Password</label>
                                                <div class="col-lg-10">
                                                        <label v-if="!ShowReadonly" for="staticEmail"
                                                                class="readonly">{{Email.Password}}</label>
                                                        <input v-else type="text" id="inputPassword"
                                                                placeholder="Host name" class="form-control "
                                                                v-model="Email.Password">
                                                </div>
                                        </div>
                                        <div class="content-block">
                                                <div class="row">
                                                        <div class="col-md-10 offset-md-2">
                                                                <button v-if="!ShowReadonly" type="submit"
                                                                        class="btn default-btn"
                                                                        @click.prevent="EditEmailSettings">
                                                                        Edit
                                                                </button>
                                                                <button v-if="ShowReadonly" type="submit"
                                                                        class="btn default-btn save-btn"
                                                                        :disabled="Disable.AddEmail"
                                                                        @click.prevent="addEmailSettings">
                                                                        Save
                                                                </button>
                                                                <button v-if="ShowReadonly" type="submit"
                                                                        class="btn default-btn cancel"
                                                                        @click.prevent="cancelEditEmailSettings">
                                                                        Cancel
                                                                </button>
                                                        </div>
                                                </div>
                                        </div>
                                </div>

                        </div>
                </div>
        </div>
</div>
</div>
